import { render } from "./Menus.vue?vue&type=template&id=530d98d0&scoped=true"
import script from "./Menus.vue?vue&type=script&lang=js"
export * from "./Menus.vue?vue&type=script&lang=js"

import "./Menus.vue?vue&type=style&index=0&id=530d98d0&lang=sass"
import "./Menus.css?vue&type=style&index=1&id=530d98d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\INFO\\Documents\\Projects\\WatersideProject\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530d98d0"]])

export default __exports__